const DEFAULT_DATA = {
    hero: {
        badge: 'ISO 27001 UYUMLULUĞU',
        badge_en: 'ISO 27001 COMPLIANCE',
        title: 'Politika ve Belge Yönetimi',
        title_en: 'Policy and Document Management',
        description:
            'ISO 27001 uyumluluğunuz için tüm önemli dokümantasyon, politika ve prosedürlerinizi tek bir merkezi platformdan yönetin. Denetimlere her an hazır olun.',
        description_en:
            'Manage all your essential documentation, policies, and procedures for ISO 27001 compliance from a single centralized platform. Stay audit-ready at all times.',
        primaryButtonText: 'Ücretsiz Deneyin',
        primaryButtonText_en: 'Try for Free',
        secondaryButtonText: 'Demoyu İzleyin',
        secondaryButtonText_en: 'Watch the Demo',
        image: null,
    },

    features: {
        Title: 'Profesyonel Belge Yönetimi Çözümleri',
        Title_en: 'Professional Document Management Solutions',
        Description:
            'ISO 27001 standartlarına tam uyumlu, güvenli ve izlenebilir bir dokümantasyon altyapısı ile operasyonel mükemmelliği yakalayın.',
        Description_en:
            'Achieve operational excellence with a secure and traceable documentation infrastructure fully compliant with ISO 27001 standards.',
        cards: [
            {
                icon: 'history',
                Title: 'Versiyon Kontrolü',
                Title_en: 'Version Control',
                Description:
                    'Belgelerin tüm revizyon geçmişini takip edin ve eski sürümlere anında güvenli erişim sağlayın.',
                Description_en:
                    'Track the full revision history of your documents and securely access previous versions instantly.',
            },
            {
                icon: 'rule',
                Title: 'Onay İş Akışları',
                Title_en: 'Approval Workflows',
                Description:
                    'Özelleştirilebilir onay mekanizmaları ile belgeleri kurumsal hiyerarşik denetimden geçirin.',
                Description_en:
                    'Route documents through organizational hierarchical reviews with customizable approval mechanisms.',
            },
            {
                icon: 'link',
                Title: 'Kontrol Eşleme',
                Title_en: 'Control Mapping',
                Description:
                    'Belgelerinizi doğrudan ISO 27001 kontrolleriyle ilişkilendirerek uyumluluğu anında kanıtlayın.',
                Description_en:
                    'Demonstrate compliance instantly by directly linking your documents to ISO 27001 controls.',
            },
            {
                icon: 'verified',
                Title: 'Kanıt Yönetimi',
                Title_en: 'Evidence Management',
                Description:
                    'Denetimler için gerekli tüm dijital kanıtları sistematik bir şekilde depolayın ve ilişkilendirin.',
                Description_en:
                    'Store and organize all digital evidence required for audits in a structured and systematic way.',
            },
        ],
    },

    modules: {
        Title: 'Belgeler: Önemli Dokümantasyon Modülleri',
        Title_en: 'Documents: Key Documentation Modules',
        modules: [
            {
                Text: 'Politika Yönetimi',
                Text_en: 'Policy Management',
                Description:
                    'Kurumsal politikalarınızı dijital ortamda oluşturun, sürümleyin ve tüm çalışanlara tek tıkla yayınlayın.',
                Description_en:
                    'Create, version, and publish your corporate policies digitally with a single click for all employees.',
                image: [],
            },
            {
                Text: 'Prosedür Takibi',
                Text_en: 'Procedure Tracking',
                Description:
                    'Operasyonel prosedürlerin güncelliğini, uygulanabilirliğini ve personel tarafından okunma durumlarını kontrol edin.',
                Description_en:
                    'Monitor the updates, applicability, and employee acknowledgment status of your operational procedures.',
                image: [],
            },
        ],
    },

    cta: {
        Title: 'ISO 27001 yolculuğunuzu bugün kolaylaştırın.',
        Title_en: 'Simplify Your ISO 27001 Journey Today',
        Description:
            'Dokümanlarınızı RUZY ile organize edin, zaman kazanın ve denetim risklerini sıfıra indirin.',
        Description_en:
            'Organize your documentation with RUZY, save time, and eliminate audit risks.',
        primaryButtonText: 'Şimdi Başlayın',
        primaryButtonText_en: 'Get Started Now',
        secondaryButtonText: 'Satışla Görüşün',
        secondaryButtonText_en: 'Contact Us',
    },
};

export default DEFAULT_DATA;